define('constants/routingRuleExitConditionsConstants',[], function() {
    return {
        timeoutInSeconds: 1,
        donePlayingAudioFile: 2,
        keyPress: 3,
        hangup: 4
    };
});
